module.exports = __webpack_public_path__ + "img/icon_warning.54e2c11a.svg";